import { IAppConfig } from '@ideals/types';

declare global {
  interface Window {
    readonly environment: IAppConfig;
  }
}

export const environment: IAppConfig = window.environment;
